import initialState from './initialState';
import { RECEIVE_VENDOR_FILE_REIMPORT_USING_VARIATION_REPORT } from '../actions/filesActions';
import { HIDE_SUCCESS_DIALOG } from '../actions/successDialogActions';
import {
  RECEIVE_SUPERVISOR_PERSIST_STATUS_FOR_USER,
  RECEIVE_SUPERVISOR_REMOVE_STATUS_FOR_USER,
  RECEIVE_VENDOR_ASSOCIATION_PERSIST_STATUS_FOR_USER,
  RECEIVE_GROUP_PERSIST_STATUS,
  RECEIVE_DIRECT_USER_GROUP_ASSOCIATION_PERSIST_STATUS,
  RECEIVE_SUPPLIER_PERSIST_STATUS,
  RECEIVE_SUPPLIER_UPDATE_STATUS,
  SUCCESS_UPDATE_SUPPLIER_CONTACT,
} from '../actions/userManagementActions';
import { SUCCESS_EVENTS, AGREEMENT_REPORT_TYPES } from '../../helpers/constants';
import {
  RECEIVE_REPORT_TEMPLATE_DELETE_STATUS,
  RECEIVE_REPORT_TEMPLATE_PERSIST_STATUS,
  RECEIVE_AGREEMENT_REPORT_CREATION_STATUS,
  RECEIVE_AGREEMENT_SUMMARY_REPORT_CREATION_STATUS,
} from '../actions/reportsActions';
import {
  RECEIVE_SUPPLIER_SUPPORT_REQUEST_SUBMISSION_RESPONSE,
  RECEIVE_WORKSPACE_REQUEST_SUBMISSION_RESPONSE,
  RECEIVE_WORKSPACE_REQUEST_ACTION_RESPONSE
} from '../actions/workspaceActions';
import {
  RECEIVE_SUCCESS_IN_MARKET_GROUP_OPERATION
} from '../actions/formulaGroupActions';
import {
  RECEIVE_SAS_VALUE_UPDATE_STATUS_FOR_VENDOR,
  RECEIVE_SAS_VALUE_ADD_STATUS_FOR_VENDOR,
  RECEIVE_SAS_FD_FILE_IMPORT,
  RECEIVE_SAS_FD_DETAILS_UPDATE_STATUS_FOR_ITEM,
  RECEIVE_ITEM_GROUP_DELETE_RESPONSE,
  RECEIVE_ITEM_GROUP_UPDATE_RESPONSE,
  RECEIVE_ITEM_GROUP_CREATE_RESPONSE,
} from '../actions/agreementActions';
import {
  RECEIVE_OVERAGE_FILE_IMPORT,
} from '../actions/costImpactTermActions';

import { RECEIVE_SUCCESS_IN_MASS_ITEM_UPLOAD_OPERATION } from '../actions/massItemUploadActions';
import {
  RECEIVE_MODULE_PRICE_EXPORT,
  RECEIVE_COMMODITY_GROUP_DELETE,
  RECEIVE_COMMODITY_GROUP_UPDATE,
  RECEIVE_CREATE_COMMODITY_GROUP,
  RECEIVE_CREATE_MODULE_GROUP,
  RECEIVE_LOADING_AREA_CREATE,
  RECEIVE_LOADING_AREA_DELETE,
  RECEIVE_LOADING_AREA_UPDATE,
  RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT,
  RECEIVE_MODULE_GROUP_DELETE,
  RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT,
  RECEIVE_MODULE_GROUP_UPDATE,
  RECEIVE_MODULE_PRICE_IMPORT,
  RECEIVE_MODULE_GROUP_REACTIVATE,
  RECEIVE_COMMODITY_GROUP_REACTIVATE,
  RECEIVE_LOADING_AREA_REACTIVATE,
  RECEIVE_UPDATE_MODULE_PRICES,
} from '../actions/costMaintenanceActions';
import {
  RECIEVE_SEGMENT_DETAILS_PERSIST_STATUS,
  RECIEVE_SEGMENT_DETAILS_UPDATE_STATUS,
  RECIEVE_SEGMENT_DETAILS_DELETE_STATUS,
  RECIEVE_SEGMENT_DETAILS_INACTIVATE_STATUS,
} from '../actions/segmentDataActions';

function generateReportCreationMessage(reportType, filenames) {
  const reportNames = filenames.join(' and ');
  const reportInfo = AGREEMENT_REPORT_TYPES[reportType];

  const isPlural = filenames.length > 1;
  const reportWord = isPlural ? 'reports' : 'report';
  const verb = isPlural ? 'are' : 'is';
  const creationVerb = isPlural ? 'have' : 'has';

  if (!reportInfo) {
    return `The ${reportWord} ${reportNames} ${verb} created`;
  }

  return `The ${reportInfo.label} Report${isPlural ? 's' : ''} ${creationVerb} been created. The ${reportWord} ${reportNames} ${verb} located at ${reportInfo.location}`;
}

export default function successReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.success;
  }
  switch (type) {
    case RECEIVE_SUCCESS_IN_MASS_ITEM_UPLOAD_OPERATION:
      return { show: true, message: data };

    case RECEIVE_SUCCESS_IN_MARKET_GROUP_OPERATION:
      return { show: true, message: data };

    case RECEIVE_VENDOR_FILE_REIMPORT_USING_VARIATION_REPORT:
      return { show: true, message: 'Accepted to load prices' };

    case RECEIVE_SUPERVISOR_PERSIST_STATUS_FOR_USER:
    case RECEIVE_VENDOR_ASSOCIATION_PERSIST_STATUS_FOR_USER:
    case RECEIVE_SUPERVISOR_REMOVE_STATUS_FOR_USER:
    case RECEIVE_DIRECT_USER_GROUP_ASSOCIATION_PERSIST_STATUS:
    case RECEIVE_SAS_VALUE_UPDATE_STATUS_FOR_VENDOR:
    case RECEIVE_SAS_FD_DETAILS_UPDATE_STATUS_FOR_ITEM:
    case RECIEVE_SEGMENT_DETAILS_UPDATE_STATUS:
    case RECEIVE_SUPPLIER_UPDATE_STATUS:
    case RECEIVE_MODULE_GROUP_UPDATE:
    case RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT:
    case RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT:
    case RECEIVE_COMMODITY_GROUP_UPDATE:
    case RECEIVE_LOADING_AREA_UPDATE:
    case RECEIVE_UPDATE_MODULE_PRICES:
      return { show: true, message: 'Updated Successfully' };

    case RECEIVE_WORKSPACE_REQUEST_ACTION_RESPONSE:
      return { show: true, message: data.message };

    case RECEIVE_SUPPLIER_SUPPORT_REQUEST_SUBMISSION_RESPONSE:
      return { show: true, message: `Support Request #${data.businessProcessId} has been submitted successfully` };

    case RECEIVE_WORKSPACE_REQUEST_SUBMISSION_RESPONSE:
      return { show: true, message: `Request #${data.businessProcessId} has been received` };

    case RECEIVE_REPORT_TEMPLATE_PERSIST_STATUS:
    case RECEIVE_GROUP_PERSIST_STATUS:
    case RECEIVE_SAS_VALUE_ADD_STATUS_FOR_VENDOR:
    case RECEIVE_LOADING_AREA_CREATE:
    case RECEIVE_CREATE_MODULE_GROUP:
    case RECEIVE_CREATE_COMMODITY_GROUP:
      return { show: true, message: 'Created Successfully', type: 'text' };

    case RECIEVE_SEGMENT_DETAILS_PERSIST_STATUS:
      return {
        show: true, message: 'Created Successfully', type: 'text', persistType: data?.persistType
      };

    case RECEIVE_AGREEMENT_REPORT_CREATION_STATUS: {
      const filenames = data.reports.map((report) => report.reportName);
      const message = generateReportCreationMessage(data.reportType, filenames);
      return { show: true, message, type: 'text' };
    }

    case RECEIVE_AGREEMENT_SUMMARY_REPORT_CREATION_STATUS: {
      const { reportType, houseTypes } = data;
      const isMultipleReport = houseTypes.length > 1;
      const reportInfo = AGREEMENT_REPORT_TYPES[reportType];
      return { show: true, message: `The ${reportInfo.label} Report request is accepted for creation. The ${isMultipleReport ? 'Reports' : 'Report'} will be located at ${reportInfo.location}` };
    }

    case RECEIVE_MODULE_PRICE_EXPORT:
      return { show: true, message: 'File Downloaded' };
    case RECEIVE_REPORT_TEMPLATE_DELETE_STATUS:
    case RECEIVE_MODULE_GROUP_DELETE:
    case RECEIVE_COMMODITY_GROUP_DELETE:
    case RECEIVE_LOADING_AREA_DELETE:
      return { show: true, message: 'Deleted Successfully' };
    case RECIEVE_SEGMENT_DETAILS_DELETE_STATUS:
      return { show: true, message: 'Deleted Successfully', event: SUCCESS_EVENTS.SEGMENT_DETAIL_DELETE };

    case RECEIVE_MODULE_GROUP_REACTIVATE:
    case RECEIVE_COMMODITY_GROUP_REACTIVATE:
    case RECEIVE_LOADING_AREA_REACTIVATE:
      return { show: true, message: 'Reactivated Successfully' };

    case RECEIVE_SAS_FD_FILE_IMPORT:
    case RECEIVE_MODULE_PRICE_IMPORT:
      return { show: true, message: 'File Accepted to Process' };

    case RECEIVE_OVERAGE_FILE_IMPORT:
      return { show: true, message: 'File Accepted to Process' };

    case RECIEVE_SEGMENT_DETAILS_INACTIVATE_STATUS:
      return { show: true, message: 'Inactivated Successfully' };

    case HIDE_SUCCESS_DIALOG:
      return { show: false, message: '', event: '' };

    case RECEIVE_SUPPLIER_PERSIST_STATUS:
      return { show: true, message: 'Supplier Profile Sucessfully Created', type: 'text' };
    case SUCCESS_UPDATE_SUPPLIER_CONTACT:
      return { show: true, message: 'Supplier Contact Details Successfully Updated', type: 'text' };
    case RECEIVE_ITEM_GROUP_DELETE_RESPONSE:
      return { show: true, message: 'Item group deleted successfully', type: 'text' };
    case RECEIVE_ITEM_GROUP_UPDATE_RESPONSE:
      return { show: true, message: 'Item group updated successfully', type: 'text' };
    case RECEIVE_ITEM_GROUP_CREATE_RESPONSE:
      return { show: true, message: `Item groups were created successfully. Generated IDs: ${data.itemGroupIdList.join(', ')}.`, type: 'text' };

    default:
      return state;
  }
}
